import { Select, SelectProps as DSSelectProps } from '@s-group/design-system-components/Select/Select'
import classNames from 'classnames'
import { ReactNode, Ref, RefAttributes } from 'react'
import { styled } from 'styled-components'

import { InputFieldProps } from '../../global/ComponentProps'
import { buildAriaAttributes } from '../../global/global'

interface SelectFieldProps extends InputFieldProps {
  hasPlaceholder?: boolean
  disablePlaceholder?: boolean
  ref?: Ref<HTMLSelectElement>
}

const TypedSelect = Select as React.ComponentType<DSSelectProps & RefAttributes<HTMLSelectElement>>

const UnstyledSelectField = ({
  id = '',
  children,
  name,
  className,
  disabled,
  defaultValue,
  onBlur,
  onChange,
  hasPlaceholder,
  placeholder = '',
  disablePlaceholder = false,
  required = true,
  error,
  description,
  tabIndex = 0,
  ref,
}: SelectFieldProps): ReactNode => (
  <TypedSelect
    ref={ref}
    id={id}
    name={name}
    defaultValue={defaultValue}
    className={classNames(className, { error: !!error })}
    error={!!error}
    required={required}
    tab-index={tabIndex}
    disabled={disabled}
    onBlur={onBlur}
    onChange={onChange}
    sizing={'medium'}
    {...buildAriaAttributes(id, required, !!description, !!error)}
    style={{ width: '100%' }}
  >
    {hasPlaceholder ? (
      <option value={defaultValue} disabled={disablePlaceholder}>
        {placeholder}
      </option>
    ) : undefined}
    {children}
  </TypedSelect>
)

export const SelectField = styled(UnstyledSelectField)`
  &:invalid:not(.error) {
    border-color: unset;
  }
`
